<template>
    <div>
        <input-select
            :multiple="multiple"
            searchable
            placeholder="Products"
            v-model="proxyValue"
            :options="products"
            :error="errors && errors['products']"
            :filterable="false"
            :loading="loading"
            label="headline_name"
            @search="onSearch"
            v-bind="$attrs"
        >
            <template #no-options="{search, searching, loading}">
                <template v-if="loading">Searching...</template>

                <template v-else>
                    <template v-if="searching">No products found</template>

                    <template v-else>Type to start searching</template>
                </template>
            </template>

            <template #option="product">
                <div class="flex items-center gap-4">
                    <p class="font-bold flex-grow">
                        {{ product.headline_name }}
                    </p>

                    <p class="hidden md:block">{{ product.identifier }}</p>

                    <div class="bg-primary rounded-full px-2 text-white hidden md:block">{{ product.type }}</div>
                </div>
            </template>
        </input-select>
    </div>
</template>

<script setup>
import AdminAppLabel from "@/Components/Admin/Forms/AdminAppLabel";
import InputSelect from "@/Components/Admin/Forms/Inputs/InputSelect";
import {computed} from "vue";
import {useProducts} from "@/Composables/useProducts";

const {onSearch, products, loading} = useProducts();

const props = defineProps({
    modelValue: [Array, Object],
    errors: Object,
    multiple: Boolean
});

const emit = defineEmits(["update:modelValue"]);

const proxyValue = computed({
    get() {
        return props.modelValue;
    },
    set(product) {
        emit("update:modelValue", product);
    }
});
</script>

<style scoped>

</style>
